export default __webpack_public_path__ + "static/media/n-back-acustico-step1.cf7847bf.svg";